import { Component, Inject, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmInputComponent } from '../confirm-input/confirm-input.component';

@Component({
    selector: 'app-double-input',
    templateUrl: './double-input.component.html',
    styleUrls: ['./double-input.component.scss'],
    standalone: false
})
export class DoubleInputComponent implements OnInit {

    inputFirst: string;
    inputSecond: string;
    @ViewChild('textInput', { static: true }) textInput: ElementRef;

    title: string;
    body: string;
    cancelText: string;
    okText: string;
    placeholderFirst: string;
    placeholderSecond: string;

    constructor( 
        private dialogRef: MatDialogRef < ConfirmInputComponent > ,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.title = data.title;
        this.body = data.body;
        this.cancelText = data.cancelText;
        this.okText = data.okText;
        this.placeholderFirst = data.placeholderFirst;
        this.placeholderSecond = data.placeholderSecond;
        this.inputFirst = data.deepLinkClubId ? data.deepLinkClubId : '';
    }

    ngOnInit() {
        this.textInput.nativeElement.focus();
    }

    confirm() {
        if (this.inputFirst === undefined) {
            this.inputFirst = '';
        }
        if (this.inputSecond === undefined) {
            this.inputSecond = '';
        }
        this.dialogRef.close({ valueFirst: this.inputFirst, valueSecond: this.inputSecond });
    }

    cancel() {
        this.dialogRef.close({ valueFirst: undefined, valueSecond: undefined });
    }
}
